import Cookies from "js-cookie";
import { cloneDeep } from "lodash";
// import { receiveServerErrors } from '../errors/error_actions';

const RECEIVE_LICENSE_VIDEO = "RECEIVE_LICENSE_VIDEO";
const RESET_LICENSE_VIDEO = "RESET_LICENSE_VIDEO";
const RECEIVE_LICENSE_AGREEMENT = "RECEIVE_LICENSE_AGREEMENT";
const RECEIVE_VIDEO_AGREEMENTS = "RECEIVE_VIDEO_AGREEMENTS";
const RECEIVE_LICENSE_AGREEMENTS = "RECEIVE_LICENSE_AGREEMENTS";
const REQUEST_LICENSE_AGREEMENTS = "REQUEST_LICENSE_AGREEMENTS";
const REQUEST_LICENSE_HISTORY = "REQUEST_LICENSE_HISTORY";
const REQUEST_PURCHASE_HISTORY = "REQUEST_PURCHASE_HISTORY";
const RECEIVE_LICENSE_HISTORY = "RECEIVE_LICENSE_HISTORY";
const RECEIVE_PURCHASE_HISTORY = "RECEIVE_PURCHASE_HISTORY";

export const receiveLicenseRequestVideo = (video) => ({
  type: RECEIVE_LICENSE_VIDEO,
  video,
});

export const resetLicenseRequestVideo = () => ({
  type: RESET_LICENSE_VIDEO,
});

const receiveLicenseAgreement = (agreement) => ({
  type: RECEIVE_LICENSE_AGREEMENT,
  agreement,
});

const receiveVideoAgreements = (licenseAgreements) => ({
  type: RECEIVE_VIDEO_AGREEMENTS,
  licenseAgreements,
});

export const receiveLicenseAgreements = (agreements) => ({
  type: RECEIVE_LICENSE_AGREEMENTS,
  agreements,
});

export const requestLicenseAgreement = (loading) => ({
  type: REQUEST_LICENSE_AGREEMENTS,
  loading,
});

const requestLicenseAgreementsHistory = (loading) => ({
  type: REQUEST_LICENSE_HISTORY,
  loading,
});

const requestPurchaseHistory = (loading) => ({
  type: REQUEST_PURCHASE_HISTORY,
  loading,
});

const receiveLicenseAgreementsHistory = (agreements) => ({
  type: RECEIVE_LICENSE_HISTORY,
  agreements,
});

const receivePurchaseHistory = (agreements) => ({
  type: RECEIVE_PURCHASE_HISTORY,
  agreements,
});

export const sendLicenseRequest =
  ({ data, message, channel, video, note }) =>
  (dispatch) => {
    $.ajax({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/license_agreements`,
      data: {
        ...data,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      },
      success(licenseAgreement) {
        const { pubnub } = window;
        pubnub.publish({
          channel,
          message: {
            message,
            publisher: licenseAgreement.requester_id,
            meta: { license_agreement: licenseAgreement._id },
          },
        });
        dispatch(receiveLicenseRequestVideo({}));
        dispatch(
          receiveLicenseAgreement({
            license_agreement: licenseAgreement,
            license_video: video,
            influencer_video_note: note,
          })
        );
      },
      error(xhr) {
        // dispatch(receiveServerErrors(xhr));
      },
    });
  };

export const fetchLicenseAgreement = (id) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/license_agreements/${id}`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(agreement) {
      dispatch(receiveLicenseAgreement(agreement));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchLicenseHistory = () => (dispatch) => {
  dispatch(requestLicenseAgreementsHistory(true));
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/license_agreements`,
    data: {
      license_history: true,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(agreements) {
      dispatch(requestLicenseAgreementsHistory(false));
      dispatch(receiveLicenseAgreementsHistory(agreements));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchPurchaseHistory = () => (dispatch) => {
  dispatch(requestPurchaseHistory(true));
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/license_agreements`,
    data: {
      purchase_history: true,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(agreements) {
      dispatch(requestPurchaseHistory(false));
      dispatch(receivePurchaseHistory(agreements));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const updateLicenseAgreement = (id, data) => (dispatch) => {
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/license_agreements/${id}`,
    data: {
      ...data,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(agreement) {
      dispatch(receiveLicenseAgreement(agreement));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchLicenseAgreementsForVideo = (id) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/license_agreements`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(licenseAgreements) {
      dispatch(receiveVideoAgreements(licenseAgreements));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const licenseRequestVideo = (state = {}, payload = {}) => {
  const { type, video } = payload;
  switch (type) {
    case RECEIVE_LICENSE_VIDEO:
      return video;
    case RESET_LICENSE_VIDEO:
      return {};
    default:
      return state;
  }
};

export const videoLicenseAgreements = (state = [], payload = {}) => {
  const { type, licenseAgreements } = payload;
  return type === RECEIVE_VIDEO_AGREEMENTS ? licenseAgreements : state;
};

export const licenseAgreements = (state = [], payload = {}) => {
  const { type, agreement, agreements } = payload;
  const newState = cloneDeep(state);
  switch (type) {
    case RECEIVE_LICENSE_AGREEMENTS:
      return agreements;
    case RECEIVE_LICENSE_AGREEMENT:
      const i = newState.findIndex(
        ({ license_agreement: { _id } }) =>
          _id === agreement.license_agreement._id
      );
      if (i === -1) {
        newState.push(agreement);
      } else {
        newState[i] = agreement;
      }
      return newState;
    default:
      return state;
  }
};

export const licenseHistory = (state = [], payload = {}) => {
  const { type, agreements } = payload;
  return type === RECEIVE_LICENSE_HISTORY ? agreements : state;
};

export const purchaseHistory = (state = [], payload = {}) => {
  const { type, agreements } = payload;
  return type === RECEIVE_PURCHASE_HISTORY ? agreements : state;
};

export const loadingLicenseHistory = (state = false, payload = {}) => {
  const { type, loading } = payload;
  return type === REQUEST_LICENSE_HISTORY ? loading : false;
};

export const loadingPurchaseHistory = (state = false, payload = {}) => {
  const { type, loading } = payload;
  return type === REQUEST_PURCHASE_HISTORY ? loading : false;
};
